import React from 'react'
import {
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { colors } from '@/theme'

const StyledTableContainer = styled(TableContainer)(() => ({
  margin: '1rem 0',

  ['& .MuiTableCell-root']: {
    color: colors.color700,
  },

  ['& .MuiTableCell-head']: {
    color: colors.color500,
    fontWeight: 'bold',
  },
}))

export function CollectScheduleRulesTable() {
  const schedules = [
    {
      operation: 'Venda / Bonificação',
      openPaletScheduleDescribe: '24h (D+1), 48h (D+2)',
      closePaletScheduleDescribe: 'No mesmo dia, 24h (D+1)',
    },
    {
      operation: 'Amostra',
      openPaletScheduleDescribe: '48h (D+2), 72h (D+3)',
      closePaletScheduleDescribe: 'No mesmo dia, 24h (D+1)',
    },
    {
      operation: 'Villahouse',
      openPaletScheduleDescribe: '72h (D+3), 96h (D+4)',
      closePaletScheduleDescribe: '24h (D+1), 48h (D+2)',
    },
    {
      operation: 'Villacol',
      openPaletScheduleDescribe: '24h (D+1), 48h (D+2)',
      closePaletScheduleDescribe: 'No mesmo dia, 24h (D+1)',
    },
  ]

  return (
    <StyledTableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell scope="col">Operação / Tipo</TableCell>
            <TableCell>Palete Aberto</TableCell>
            <TableCell>Palete Fechado</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {schedules.map((schedule, index) => {
            const [openPaletBefore, openPaletAfter] =
              schedule.openPaletScheduleDescribe.split(',')

            const [closePaletBefore, closePaletAfter] =
              schedule.closePaletScheduleDescribe.split(',')

            return (
              <TableRow key={index}>
                <TableCell scope="col" width="30%">
                  {schedule.operation}
                </TableCell>

                <TableCell width="auto">
                  Antes 12h → <b>{openPaletBefore}</b>
                  <br /> Após 12h → <b>{openPaletAfter}</b>
                </TableCell>

                <TableCell width="auto">
                  Antes 12h → <b>{closePaletBefore}</b>
                  <br /> Após 12h → <b>{closePaletAfter}</b>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </StyledTableContainer>
  )
}
